import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const formContainerV3Migration: PropsMigration = {
  mode: 'props',
  description:
    'Migrate Form Container element to v3 by migrating label color to label & icon colors',
  run: (props: PartialPropsOf<'formContainer'>): void => {
    const formContainerProps = props;

    if (
      formContainerProps?.style?.container?.title &&
      !formContainerProps?.content?.title?.iconColor
    ) {
      const currentColor = formContainerProps.style.container.title.color1;
      formContainerProps.content = {
        ...formContainerProps.content,
        title: {
          ...formContainerProps.content?.title,
          iconColor: { color1: currentColor },
        },
      };
    }
  },
};
